import { constants } from "@newsela/angelou";

export const buttonCss = {
  root: {
    width: "100%",
    height: 48,
    backgroundColor: "#416FE4",
    padding: "4px 28px 4px 8px",
    borderRadius: 4,
    textDecoration: "none",
    color: constants.colors.ui.white[50],
    whiteSpace: "nowrap",
    div: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      textAlign: "left",
    },
    span: {
      width: "100%",
      marginLeft: 8,
    },
  },
  Icon: {
    root: {
      width: "100%",
      maxWidth: 40,
      minWidth: 40,
      margin: 0,
    },
  },
};
